import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import TableCoreComponent from './../../../reusable/LightTable/TableCoreComponent';
import entitiesApi from './../../../api/Entities.api';
import VeryLightTable from './../../../reusable/LightTable/VeryLightTable';
import { compose } from 'redux';
import withInfiniteScroll from '../../../reusable/LightTable/hoc/Scrollable';

const Table = compose(
    withInfiniteScroll
)(VeryLightTable);

export default class SeeAllEntitiesTable extends TableCoreComponent {
    static propTypes = {
        listItems: PropTypes.array
    };

    static defaultProps = {
        listItems: []
    };

    constructor(props) {
        super(props);

        this.defaultLoadParams = {
            filters:    {
                categoryIdFilter: props.category.category.id,
                query:            ""
            },
            sorting:    {
                direction: "asc",
                sortBy:    "companyTitle"
            },
            pagination: {
                pageNumber: 0,
                pageSize:   50
            },
            reset:      false
        };

        this.loadParams = this.defaultLoadParams;
        this.api = entitiesApi;
    }

    formatItem = (item) => {
        return {
            key:  item.id,
            name: item.companyTitle
        }
    };

    headerItems = [
        {
            key:   "name",
            label: <FormattedMessage id='Category_Manage_UIText_tableHeaderElement.entities' />
        }
    ];

    loadItems(params, retry = false) {
        this.props.isLoadingHandler(true);
        return super.loadItems(params, retry).then(
            () => {
                this.props.isLoadingHandler(false);
            }
        )
    }

    render = () => <div className="selectable-table">
        <Table {...this.getTableProps()} />
        {this.state.activeModal && this.state.activeModal}
    </div>
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/SeeAllEntitiesTable.jsx